import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import React, { FC, ReactNode } from "react";
import { styled } from "@material-ui/styles";

import brandGenLogo from "../../assets/images/logo_blue_black.svg";

const Root = styled(Box)({
  width: "90%",
  maxWidth: 1130,
  minHeight: "100vh",
  margin: "0 auto",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const LeftPanel = styled(Box)({
  width: "50%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
});

const RightPanel = styled(Box)({
  width: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const CardPaper = styled(Paper)(({ theme }) => ({
  width: "100%",
  maxWidth: 544,
  padding: "40px 36px",
  borderRadius: 10,
  border: `1px solid ${theme.palette.brand.gray200}`,
}));

type BrandAuthLayoutProps = {
  children: ReactNode;
  heading?: string;
  description?: string;
};

const BrandAuthLayout: FC<BrandAuthLayoutProps> = ({
  children,
  heading = "Welcome Back",
  description = "Log in: to view your personalized dashboard, campaigns, and audiences.",
}) => {
  return (
    <Root>
      <LeftPanel>
        <img src={brandGenLogo} alt="BrandGen Logo" style={{ width: 250 }} />
        <Typography
          variant="h1"
          style={{
            marginTop: 32,
            fontSize: 56,
            fontWeight: 600,
            lineHeight: "69px",
          }}
        >
          {heading}
        </Typography>
        <Typography
          style={{
            fontSize: 18,
            marginTop: 12,
            maxWidth: 377,
            lineHeight: "24px",
          }}
        >
          {description}
        </Typography>
      </LeftPanel>

      <RightPanel>
        <CardPaper elevation={0}>{children}</CardPaper>
      </RightPanel>
    </Root>
  );
};

export default BrandAuthLayout;
